// lib/google.ts
// LÀM GÌ?          Nhận link Google (Drive file / Docs / Sheets / Slides) → trả URL nhúng được (iframe) + loại.
// VÌ SAO TỒN TẠI?  Link chia sẻ dạng /view, /edit bị Google chặn nhúng; phải đổi sang /preview hoặc /embed.
//                  Cùng pattern với lib/youtube.ts.
// DB SCHEMA:       lessons.content_url (content_type = 'document' | 'slide')
// FILE NÀO DÙNG:   components/lesson/renderers/GoogleEmbedRenderer.tsx (+ LessonForm để validate link)

export type GoogleKind = "drive" | "docs" | "sheets" | "slides";
export interface GoogleEmbed { kind: GoogleKind; id: string; embedUrl: string; openUrl: string }

const RULES: { kind: GoogleKind; re: RegExp; embed: (id: string) => string; open: (id: string) => string }[] = [
  { kind: "docs",   re: /docs\.google\.com\/document\/d\/([\w-]{10,})/,     embed: id => `https://docs.google.com/document/d/${id}/preview`,     open: id => `https://docs.google.com/document/d/${id}/view` },
  { kind: "sheets", re: /docs\.google\.com\/spreadsheets\/d\/([\w-]{10,})/, embed: id => `https://docs.google.com/spreadsheets/d/${id}/preview`, open: id => `https://docs.google.com/spreadsheets/d/${id}/view` },
  { kind: "slides", re: /docs\.google\.com\/presentation\/d\/([\w-]{10,})/, embed: id => `https://docs.google.com/presentation/d/${id}/embed?start=false&loop=false`, open: id => `https://docs.google.com/presentation/d/${id}/view` },
  { kind: "drive",  re: /drive\.google\.com\/file\/d\/([\w-]{10,})/,        embed: id => `https://drive.google.com/file/d/${id}/preview`,          open: id => `https://drive.google.com/file/d/${id}/view` },
  { kind: "drive",  re: /drive\.google\.com\/(?:open|uc)\?(?:.*&)?id=([\w-]{10,})/, embed: id => `https://drive.google.com/file/d/${id}/preview`, open: id => `https://drive.google.com/file/d/${id}/view` },
];

export function parseGoogleUrl(url: string | null | undefined): GoogleEmbed | null {
  if (!url) return null;
  for (const r of RULES) {
    const m = url.match(r.re);
    if (m) return { kind: r.kind, id: m[1], embedUrl: r.embed(m[1]), openUrl: r.open(m[1]) };
  }
  return null;
}

export const isGoogleUrl = (url: string | null | undefined) => !!parseGoogleUrl(url);